// slices/accessSlice.js
import { createSlice } from '@reduxjs/toolkit';

const accessSlice = createSlice({
  name: 'access',
  initialState: { accessDetails: null },
  reducers: {
    setAccessDetails: (state, action) => {
      state.accessDetails = action.payload;
    },
    clearAccessDetails: () => ({ accessDetails: null }),
  },
});

export const { setAccessDetails, clearAccessDetails } = accessSlice.actions;
export default accessSlice.reducer;
